/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of examtemplates (patients) to display or load examtemplates */


(function () {
  'use strict';
  angular.module('vcexamtemplate')
    .component('examtemplatelist', {
      restrict: 'E',
      bindings: {
        examtemplates: '<?'
      },
      template: `
        <h3>Bestehende Befundvorlagen</h3>
        <table class="table table-striped">
          <tr>
            <th width="10%">Ordnung</th>
            <th width="10%">Kürzel</th>
            <th width="50%">Name</th>
            <th width="10%">Typ</th>
            <th width="10%">Aktiv</th>
            <th width="15%">Aktion</th>
          </tr>
          <tr ng-repeat="t in vm.examtemplates | orderBy :template.nr">
            <td><input class="form-control" type="number" ng-model="t.template.nr" ng-blur="vm.saveTemplate(t)"/> </td>
            <td ng-bind="t.template.type"></td>
            <td ng-bind="t.template.displayname"></td>
            <td>
                <span ng-show="t.template.includefindings === true" uib-tooltip="Befund wird im Gesamtbefund inkludiert"><i class="fa fa-file-text-o"></i></span>
                <span ng-show="t.template.includefindings === false" uib-tooltip="Befund wird als seperate Datei erstellt"><i class="fa fa-files-o"></i></span>
            </td>
            <td>
              <div class="btn"
                   ng-class="t.active ? 'btn-success' : 'btn-danger'"
                   ng-model="t.active"
                   ng-click="vm.toggleActive(t)"
                   uib-tooltip="Status ändern">
                <span ng-show="t.active == true">Aktiv</span>
                <span ng-show="t.active == false">Nicht aktiv</span>
              </div>
            </td>
            <td>
              <div class="btn btn-primary"
                   ng-click="vm.editTemplate(t)"
                   uib-tooltip="Editieren"><i class="fa fa-edit"></i>
              </div>
              <div class="btn btn-primary"
                   ng-click="vm.testTemplate(t)"
                   uib-tooltip="Ausprobieren"><i class="fa fa-eye"></i>
              </div>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Examtemplate', 'ExamtemplateHelper', 'vertxEventBusService', 'Exam', 'ExamHelper',
        function ($log, $http, Rlog, Examtemplate, ExamtemplateHelper, vertxEventBusService, Exam, ExamHelper) {
          let vm = this;
          vm.editExamtemplate = ExamtemplateHelper.editExamtemplate;
          vm.toggleActive = toggleActive;
          vm.editTemplate = ExamtemplateHelper.editExamtemplate;
          vm.testTemplate = testTemplate;
          vm.saveTemplate = saveTemplate;


          vm.$onInit = function () {
            // unless examtemplates list has been passed for test purposes, retrieve examtemplates list from web
            if (angular.isUndefined(vm.examtemplates)) {
              vm.examtemplates = Examtemplate.$search();
            }
          }; // $onInit()


          function toggleActive(examtemplate) {
            examtemplate.active = !examtemplate.active;
            examtemplate.$save();
          }

          function testTemplate(template) {
            $http.get('/routes/patients/sampledata/').then(function (pat) {
              startSampleExam(pat.data, template);
            }, function (err) {
              $log.error('Loading of sampledata patient failed', err);
            });
          }

          function saveTemplate(template){
            template.$save().$then((res) => {}, (err) => $log.info('failed to save templ: ', err));
          }

          function startSampleExam(pat, et) {
            let newexam = {};
            newexam.templateid = et._id;
            newexam.print = true;
            newexam.patientid = pat._id;
            newexam.clientid = pat._id;
            newexam.consultid = '1234';
            newexam.patlastname = pat.primarycontact.lastname;
            newexam.patfirstname = pat.primarycontact.firstname;
            newexam.templateid = et._id;
            newexam.template = angular.copy(et.template);
            newexam.type = et.template.displayname;
            newexam.test = true;
            newexam.fdate = moment().locale('de-at').format('ll');
            $log.debug('Newexam before insert: ', newexam);
            Exam.$create(newexam)
              .$then(function (exam) {
                $log.debug('exam for template test sucessfully created: ', exam);
                ExamHelper.editSampleExam(exam);
              }, function (err) {
                $log.error('exam creation for template test failes: ', err);
              });

          }

          const etUpdateHandler = function (message) {
            $log.debug('debug: examtemplate update received: ', message);
            if (angular.isDefined(vm.examtemplates)){
              vm.examtemplates.$refresh().$then(function () {
                $log.debug('debug: examtemplatelist refreshed examtemplates');
              }, function (error) {
                $log.debug('debug: examtemplatelist refresh examtemplates failed: ', error);
              });
            }
          };

          vertxEventBusService.on('examtemplates.update', {}, etUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('examtemplates.update', {}, etUpdateHandler);
          };


        }] // controller
    }); // component

  // klammerfriedhof
}());
